import { render, staticRenderFns } from "./InputTextarea.vue?vue&type=template&id=41510cac&scoped=true&"
import script from "./InputTextarea.vue?vue&type=script&lang=ts&"
export * from "./InputTextarea.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextarea.vue?vue&type=style&index=0&id=41510cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41510cac",
  null
  
)

export default component.exports